import ElectronIPC from '@/services/ElectronIPC'
import { useEffect, useRef } from 'react'

function set(numCards: number, isRetracted: boolean, measuredDivRef: React.RefObject<HTMLDivElement>) {
    console.log(`FloatingTopStatusBar/useEffect: numCards=${numCards} isRetracted=${isRetracted}`)

    if (isRetracted) {
        const width = 120

        const params: Parameters<typeof ElectronIPC.setWindowBounds>[0] = {
            windowName: 'FloatingTopStatusBar',
            width: width,
            allowSmallHeight: true,
            noScreenBoundsCheck: true,
        }
        ElectronIPC.setWindowBounds(params)
    } else {
        const child = measuredDivRef.current
        if (child) {
            const width = child.scrollWidth + 10 // some padding

            console.log(`FloatingTopStatusBar/useWindowFit: setting window width=${width}`)

            const params: Parameters<typeof ElectronIPC.setWindowBounds>[0] = {
                windowName: 'FloatingTopStatusBar',
                width: width,
                allowSmallHeight: true,
                noScreenBoundsCheck: true,
            }
            ElectronIPC.setWindowBounds(params)
        } else {
            console.log(`FloatingTopStatusBar/useWindowFit: child is null!`)
        }
    }
}

export default function useFloatingStatusBarWindowFit(numCards: number, isRetracted: boolean) {
    const measuredDivRef = useRef<HTMLDivElement>(null)

    const timerRef = useRef<NodeJS.Timeout | undefined>(undefined)
    useEffect(() => {
        clearTimeout(timerRef.current)
        set(numCards, isRetracted, measuredDivRef)
        timerRef.current = setTimeout(() => {
            set(numCards, isRetracted, measuredDivRef)
        }, 100)

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
            }
        }
    }, [numCards, isRetracted, measuredDivRef.current])

    return { measuredDivRef }
}
